(function footerMenu($, Drupal) {
  Drupal.behaviors.footerMenu = {
    attach(context) {
      // Set variables
      const menu = $('.footer-menu > .footer-menu__items', context);
      const mql = window.matchMedia('(max-width: 767px)');
      let count = 0;

      function addCollapseMenu(heading, content) {
        // Set the attributes for Collapse Heading
        if (!(heading.hasClass('collapse__heading'))) {
          heading.attr({
            'data-toggle': 'collapse',
            'aria-expanded': 'false',
            'aria-controls': `collapse--${count}`,
            href: `#collapse--${count}`,
          });
          heading.addClass('collapse__heading');
        }

        // Set the attribute for Collapse Content
        if (!(content.hasClass('collapse'))) {
          content.attr({
            id: `collapse--${count}`,
            'aria-labelledby': `collapse--${count}`,
          });
          content.addClass('collapse');
        }

        // Increase count
        count += 1;
      }

      function removeCollapseMenu(heading, content) {
        // Remove attributes
        if (heading.hasClass('collapse__heading')) {
          heading.removeClass('collapse__heading');
          heading.removeAttr('id data-toggle aria-expanded aria-controls href');
        }

        if (content.hasClass('collapse')) {
          content.removeClass('collapse');
          content.removeAttr('id collapse aria-labelledby aria-expanded height');
        }

        count = 0;
      }

      function checkWindowWidth(heading, content) {
        // If the viewport is on extra small device, trigger mobile menu
        if (mql.matches) {
          addCollapseMenu(heading, content);
        }
        // Else, disable mobile menu
        else {
          removeCollapseMenu(heading, content);
        }
      }

      // Triggers a function after user finishes resizing the browser
      function doneResizing() {
        menu.find('.footer-menu__item').each(function () {
          const collapseHeading = $(this).find('.footer-menu__title-link');
          const collapseContent = collapseHeading.next('.footer-menu__items');

          checkWindowWidth(collapseHeading, collapseContent);
        });
      }

      menu.find('.footer-menu__item').once().each(function () {
        // Find the elements to add the collapse classes to
        const collapseHeading = $(this).find('.footer-menu__title-link');
        const collapseContent = collapseHeading.next('.footer-menu__items');

        if (mql.matches) {
          addCollapseMenu(collapseHeading, collapseContent);
        }
      });

      // Enable Bootstrap Collapse Menu
      $('.collapse').collapse('hide');

      // Register Resize Function
      let resizeTimer;

      $(window).resize(() => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(doneResizing, 300);
      });
    },
  };
}(jQuery, Drupal));
